<!--
Author: TangChen
Date: 2018-10-18
Desc: 现金宝优点
 -->
<template>
    <div v-if="qlists.length > 0" :class="'bizcomp-currency-explanation bizcomp ' + className">
        <comp-title :title="title" />
        <el-row class="currency-explanation-con">
            <el-col v-for="item in qlists" :key="item.question" :span="24">
                <div class="question">
                    {{ item.question }}
                </div>
                <div class="answer">
                    {{ item.answer }}
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "CurrencyExplanation",
    mixins: [mixin],
    data() {
        return {
            qlists: [
                {
                    question: "使用现金宝有什么好处，现金宝能为我带来什么?",
                    answer: "投资者可将每月不用的闲钱从银行卡“充值”到“现金宝”中，获得每日收益分配，安心稳定；从“现金宝”“取现”也很方便，无需任何手续。"
                },
                {
                    question: "现金宝充值金额有上下限吗？",
                    answer: "现金宝“充值”金额下限为0.01元，上限以各银行划款上限为准。 "
                },
                {
                    question: "使用现金宝快速取现服务有时间限制吗？",
                    answer: "每个自然日7*24小时，且节假日均可使用。若银行端升级等影响到快速取现，手机客户端等会提前进行公告，麻烦留意关注！"
                }
            ]
        };
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-currency-explanation {
    .currency-explanation-con {
        padding: 0 25px 20px;
        .el-col {
            line-height: 25px;
            padding: 18px 0 22px;
            border-bottom: 2px dashed $border-color3;
            .question {
                margin-bottom: 12px;
            }
            .question:before,
            .answer:before {
                color: $text-color6;
                font-size: $f16;
                text-align: center;
                width: 25px;
                height: 25px;
                display: inline-block;
                background-color: var(--color-primary);
                margin-right: 9px;
                border-radius: 3px 3px;
            }
            .question:before {
                content: "问";
            }
            .answer:before {
                content: "答";
                background-color: $color-b;
            }
        }
    }
}
</style>
